/* libs/shared/src/lib/components/anthropic-ai-assistant/anthropic-ai-assistant.component.scss */
.ai-assistant-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: transparent;
  z-index: 9998;
  pointer-events: none;
}
.ai-assistant-panel {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 700px;
  max-width: 90vw;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  animation: slideInFromRight 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  font-family:
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    Roboto,
    Helvetica,
    Arial,
    sans-serif;
  transition: width 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  pointer-events: auto;
  z-index: 9998;
}
.ai-assistant-panel.expanded {
  width: calc(100vw - 60px);
  max-width: calc(100vw - 60px);
  flex-direction: row;
}
@media (max-width: 768px) {
  .ai-assistant-panel {
    width: 100%;
    max-width: 100%;
  }
  .ai-assistant-panel.expanded {
    width: 100vw;
    max-width: 100vw;
    flex-direction: column;
  }
}
.preview-render-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #e0e4e8;
  background: #ffffff;
  min-width: 0;
  overflow: hidden;
}
@media (max-width: 768px) {
  .preview-render-panel {
    border-right: none;
    border-bottom: 1px solid #e0e4e8;
    max-height: 50vh;
  }
}
.preview-render-header {
  display: flex;
  align-items: center;
  padding: 12px 20px;
  background: #f8fafc;
  border-bottom: 1px solid #e0e4e8;
  flex-shrink: 0;
}
.preview-tabs {
  display: flex;
  gap: 4px;
  background: #edf2f7;
  border-radius: 8px;
  padding: 3px;
}
.preview-tab-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 7px 16px;
  border: none;
  background: transparent;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  color: #475569;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}
.preview-tab-btn i {
  font-size: 13px;
}
.preview-tab-btn:hover:not(.active) {
  background: rgba(0, 0, 0, 0.04);
  color: #1e293b;
}
.preview-tab-btn.active {
  background: #ffffff;
  color: #5e60ce;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
.preview-render-body {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.preview-iframe {
  width: 100%;
  height: 100%;
  border: none;
  background: #ffffff;
  flex: 1;
}
.preview-code-content {
  flex: 1;
  overflow-y: auto;
  padding: 16px 20px;
}
.preview-code-content::-webkit-scrollbar {
  width: 6px;
}
.preview-code-content::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}
.preview-code-content .preview-section {
  margin-bottom: 20px;
}
.preview-code-content .preview-section h4 {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 10px 0;
  font-size: 13px;
  font-weight: 600;
  color: #475569;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.preview-code-content .preview-section h4 i {
  font-size: 14px;
  color: #94a3b8;
}
.preview-code-content .preview-section .code-preview {
  background: #1e293b;
  color: #e2e8f0;
  padding: 14px 16px;
  border-radius: 8px;
  font-family:
    "Consolas",
    "Monaco",
    "Courier New",
    monospace;
  font-size: 12px;
  line-height: 1.6;
  overflow-x: auto;
  overflow-y: auto;
  max-height: 400px;
  border: 1px solid #334155;
  white-space: pre-wrap;
  word-wrap: break-word;
  word-break: break-all;
}
.preview-code-content .preview-section .code-preview::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
.preview-code-content .preview-section .code-preview::-webkit-scrollbar-track {
  background: #0f172a;
  border-radius: 4px;
}
.preview-code-content .preview-section .code-preview::-webkit-scrollbar-thumb {
  background: #475569;
  border-radius: 4px;
}
.preview-code-content .preview-section .code-preview::-webkit-scrollbar-thumb:hover {
  background: #64748b;
}
.preview-code-content .preview-section .html-subsection {
  margin-bottom: 16px;
}
.preview-code-content .preview-section .html-subsection:last-child {
  margin-bottom: 0;
}
.preview-code-content .preview-section .html-subsection h5 {
  margin: 0 0 8px 0;
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding-left: 4px;
  border-left: 3px solid #5e60ce;
}
.preview-code-content .preview-section .controls-preview {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.preview-code-content .preview-section .controls-preview .control-chip {
  background: #eef2ff;
  color: #5e60ce;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  border: 1px solid rgba(94, 96, 206, 0.2);
}
.preview-render-footer {
  display: flex;
  gap: 12px;
  padding: 12px 20px;
  background: #f8fafc;
  border-top: 1px solid #e0e4e8;
  justify-content: flex-end;
  flex-shrink: 0;
}
.preview-render-footer .btn {
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  border: 1px solid transparent;
  transition: all 0.2s;
}
.preview-render-footer .btn.btn-secondary {
  background: white;
  border-color: #e0e4e8;
  color: #475569;
}
.preview-render-footer .btn.btn-secondary:hover {
  background: #f1f5f9;
}
.preview-render-footer .btn.btn-primary {
  background: #5e60ce;
  color: white;
}
.preview-render-footer .btn.btn-primary:hover {
  background: #4d4fc7;
}
.chat-panel {
  width: 100%;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #ffffff;
}
.expanded .chat-panel {
  flex: 0 0 auto;
  width: 700px;
}
@media (max-width: 1024px) {
  .expanded .chat-panel {
    width: 400px;
  }
}
@media (max-width: 768px) {
  .expanded .chat-panel {
    width: 100%;
    flex: 1;
  }
}
.ai-assistant-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background: #ffffff;
  border-bottom: 1px solid #e0e4e8;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.02);
  flex-shrink: 0;
}
.ai-assistant-header .header-title {
  display: flex;
  align-items: center;
  gap: 12px;
}
.ai-assistant-header .header-title i {
  font-size: 20px;
  color: #5e60ce;
}
.ai-assistant-header .header-title h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
  letter-spacing: -0.3px;
}
.ai-assistant-header .header-actions {
  display: flex;
  gap: 8px;
}
.ai-assistant-header .header-actions button {
  background: transparent;
  border: none;
  min-width: 32px;
  height: 32px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  color: #475569;
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 0 8px;
}
.ai-assistant-header .header-actions button i {
  font-size: 16px;
}
.ai-assistant-header .header-actions button .action-label {
  font-size: 12px;
  white-space: nowrap;
}
.ai-assistant-header .header-actions button:hover {
  background: #f1f5f9;
  color: #1e293b;
}
.ai-assistant-header .header-actions button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.ai-assistant-header .header-actions button.close-btn:hover {
  background: #fee2e2;
  color: #ef4444;
}
.ai-assistant-header .header-actions button.action-btn:hover {
  background: #fef3c7;
  color: #d97706;
}
.token-usage-bar {
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 6px 16px;
  background:
    linear-gradient(
      135deg,
      #f0f4ff 0%,
      #f5f0ff 100%);
  border-bottom: 1px solid #e0e4e8;
  flex-shrink: 0;
}
.token-usage-bar .token-stat {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  color: #475569;
}
.token-usage-bar .token-stat i {
  font-size: 10px;
  color: #5e60ce;
}
.token-usage-bar .token-stat .token-label {
  font-weight: 500;
}
.token-usage-bar .token-stat .token-value {
  font-weight: 700;
  color: #1e293b;
}
.ai-assistant-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0;
  overflow: hidden;
  background: #f8fafc;
  position: relative;
}
.messages-container {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.messages-container::-webkit-scrollbar {
  width: 6px;
}
.messages-container::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}
.message {
  display: flex;
  gap: 12px;
  animation: fadeIn 0.3s ease-in;
  max-width: 100%;
}
.message.user-message {
  flex-direction: row-reverse;
}
.message.user-message .message-content {
  background: #5e60ce;
  color: white;
  border: none;
  border-radius: 12px 12px 2px 12px;
  box-shadow: 0 2px 8px rgba(94, 96, 206, 0.25);
}
.message.user-message .message-avatar {
  background:
    linear-gradient(
      135deg,
      #5e60ce 0%,
      #3a3cbf 100%);
  color: white;
}
.message.user-message .message-timestamp {
  color: rgba(255, 255, 255, 0.8);
  text-align: right;
}
.message.assistant-message .message-content {
  background: white;
  border: 1px solid #e0e4e8;
  border-radius: 12px 12px 12px 2px;
  color: #1e293b;
}
.message.assistant-message .message-text ::ng-deep .agent-table {
  width: 100%;
  border-collapse: collapse;
  margin: 8px 0;
  font-size: 13px;
}
.message.assistant-message .message-text ::ng-deep .agent-table th,
.message.assistant-message .message-text ::ng-deep .agent-table td {
  padding: 6px 10px;
  text-align: left;
  border: 1px solid #e0e4e8;
}
.message.assistant-message .message-text ::ng-deep .agent-table th {
  background: #f1f3f5;
  font-weight: 600;
  color: #1e293b;
}
.message.assistant-message .message-text ::ng-deep .agent-table tr:nth-child(even) {
  background: #fafbfc;
}
.message.assistant-message .message-text ::ng-deep .agent-table tr:hover td {
  background: #eef1f4;
}
.message.assistant-message .message-text ::ng-deep p {
  margin: 2px 0;
}
.message.assistant-message .message-text ::ng-deep ul.agent-list,
.message.assistant-message .message-text ::ng-deep ol.agent-list {
  margin: 4px 0;
  padding-left: 22px;
}
.message.assistant-message .message-text ::ng-deep ul.agent-list li,
.message.assistant-message .message-text ::ng-deep ol.agent-list li {
  margin: 3px 0;
  font-size: 13px;
  line-height: 1.5;
}
.message.assistant-message .message-text ::ng-deep ul.agent-list {
  list-style: disc;
}
.message.assistant-message .message-text ::ng-deep ol.agent-list {
  list-style: decimal;
}
.message.assistant-message .message-text ::ng-deep code {
  background: #f1f3f5;
  border-radius: 3px;
  padding: 1px 4px;
  font-size: 12px;
  font-family: monospace;
}
.message.assistant-message .message-avatar {
  background:
    linear-gradient(
      135deg,
      #7c3aed 0%,
      #5e60ce 50%,
      #4f46e5 100%);
  color: white;
  border: none;
  box-shadow: 0 0 12px rgba(94, 96, 206, 0.4);
}
.message.assistant-message .message-avatar i {
  filter: drop-shadow(0 0 3px rgba(255, 255, 255, 0.6));
}
.message.system-message {
  justify-content: center;
  margin: 8px 0;
}
.message.system-message .message-content {
  background: #e0f2fe;
  color: #0369a1;
  border-radius: 20px;
  text-align: center;
  font-size: 13px;
  padding: 6px 16px;
  box-shadow: none;
  border: 1px solid #bae6fd;
}
.message.system-message .message-avatar {
  display: none;
}
.message.processing .message-avatar {
  background: transparent;
  border: none;
  color: #5e60ce;
}
.message-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 14px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}
.message-avatar i {
  font-size: 14px;
  width: auto;
  height: auto;
}
.message-content {
  max-width: 85%;
  padding: 12px 16px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  position: relative;
}
.message-text {
  word-wrap: break-word;
  white-space: pre-wrap;
  line-height: 1.5;
  font-size: 14px;
  max-height: 300px;
  overflow-y: auto;
}
.message-text::-webkit-scrollbar {
  width: 4px;
}
.message-text::-webkit-scrollbar-track {
  background: transparent;
}
.message-text::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.15);
  border-radius: 4px;
}
.message-text::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3);
}
.message-timestamp {
  font-size: 11px;
  opacity: 0.6;
  margin-top: 6px;
  display: block;
}
.ai-assistant-input {
  border-top: 1px solid #e0e4e8;
  background: white;
  padding: 16px 20px;
  position: relative;
  flex-shrink: 0;
}
.ai-assistant-input .error-message {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  background: #fef2f2;
  color: #ef4444;
  border: 1px solid #fecaca;
  border-radius: 6px;
  margin-bottom: 12px;
  font-size: 13px;
}
.ai-assistant-input .error-message i {
  font-size: 16px;
}
.attached-images {
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
  flex-wrap: wrap;
}
.attached-images .image-preview {
  position: relative;
  width: 60px;
  height: 60px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e0e4e8;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.attached-images .image-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.attached-images .image-preview .remove-image {
  position: absolute;
  top: 2px;
  right: 2px;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  border: none;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
}
.attached-images .image-preview .remove-image i {
  font-size: 10px;
}
.attached-images .image-preview .image-name {
  display: none;
}
.quick-actions {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
  overflow-x: auto;
  padding-bottom: 4px;
}
.quick-actions::-webkit-scrollbar {
  height: 0;
  width: 0;
}
.quick-actions .quick-action-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  padding: 6px 12px;
  background: #f1f5f9;
  border: 1px solid #e0e4e8;
  border-radius: 16px;
  color: #475569;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s;
}
.quick-actions .quick-action-btn i {
  font-size: 12px;
  color: #5e60ce;
}
.quick-actions .quick-action-btn:hover {
  background: #e2e8f0;
  color: #1e293b;
}
.input-container {
  display: flex;
  align-items: flex-end;
  gap: 10px;
  background: white;
}
.input-container .attach-button {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid transparent;
  background: transparent;
  color: #94a3b8;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}
.input-container .attach-button:hover:not(:disabled) {
  background: #f1f5f9;
  color: #5e60ce;
}
.input-container .attach-button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
.input-container .attach-button i {
  font-size: 18px;
}
.input-container textarea {
  flex: 1;
  padding: 12px 16px;
  border: 1px solid #e0e4e8;
  border-radius: 20px;
  background: #f8fafc;
  font-family: inherit;
  font-size: 14px;
  resize: none;
  max-height: 120px;
  min-height: 44px;
  line-height: 1.5;
  transition: all 0.2s;
}
.input-container textarea:focus {
  outline: none;
  border-color: #5e60ce;
  background: white;
  box-shadow: 0 0 0 3px rgba(94, 96, 206, 0.1);
}
.input-container textarea:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}
.input-container textarea::placeholder {
  color: #94a3b8;
}
.input-container .send-button {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  background: #5e60ce;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  box-shadow: 0 2px 5px rgba(94, 96, 206, 0.3);
}
.input-container .send-button:hover:not(:disabled) {
  background: #4d4fc7;
  transform: scale(1.05);
}
.input-container .send-button:disabled {
  background: #e2e8f0;
  color: #94a3b8;
  cursor: not-allowed;
  box-shadow: none;
}
.input-container .send-button i {
  font-size: 16px;
  margin-left: -2px;
}
.agent-confirmation-card {
  margin: 0 20px 12px;
  padding: 16px;
  border: 1px solid var(--border-color, #e0e0e0);
  border-radius: 8px;
  background-color: var(--surface-color, #fafafa);
  flex-shrink: 0;
}
.agent-confirmation-card .confirmation-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  font-weight: 500;
  color: var(--warn-color, #f57c00);
}
.agent-confirmation-card .confirmation-header mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.agent-confirmation-card .confirmation-summary {
  margin-bottom: 16px;
  padding: 12px;
  background-color: var(--background-color, #fff);
  border-radius: 4px;
  white-space: pre-wrap;
  line-height: 1.5;
  font-size: 14px;
  color: #1e293b;
}
.agent-confirmation-card .confirmation-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}
.agent-result-card {
  margin: 0 20px 12px;
  padding: 12px 16px;
  border: 1px solid var(--border-color, #e0e4e8);
  border-left: 3px solid #5e60ce;
  border-radius: 8px;
  background-color: var(--surface-color, #fafafa);
  flex-shrink: 0;
  animation: slideUp 0.3s ease;
}
.agent-result-card__header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  font-weight: 500;
  font-size: 13px;
  color: #5e60ce;
}
.agent-result-card__icon {
  font-size: 14px;
}
.agent-result-card__body {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.agent-result-card__link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #5e60ce;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  text-decoration: none;
}
.agent-result-card__link:hover {
  text-decoration: underline;
  color: #4d4fc7;
}
.agent-result-card__action {
  font-size: 11px;
  font-weight: 400;
  opacity: 0.75;
  background: rgba(94, 96, 206, 0.08);
  border-radius: 4px;
  padding: 2px 6px;
}
.agent-result-card__children {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  margin-top: 4px;
}
.agent-result-card__children-label {
  font-size: 12px;
  color: #475569;
  font-weight: 500;
}
.agent-result-card__child {
  font-size: 12px;
  color: #475569;
  background: var(--background-color, #f1f5f9);
  border-radius: 4px;
  padding: 2px 8px;
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
@keyframes slideInFromRight {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}
@keyframes slideOutRight {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(100%);
  }
}
@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
/*# sourceMappingURL=anthropic-ai-assistant.component.css.map */
